import { render } from "./ClearTextIcon.vue?vue&type=template&id=985f283a"
const script = {}
script.render = render

export default script